<template>
	<div>
		<div class="background" :style="{ backgroundImage: `url(/static/parallax-bg.jpg)`, backgroundPosition: `center ${-scrolledSize/10}px` }"></div>
	</div>
</template>

<script>
	export default {
		name: 'parallaxingBg',
		props: {
			image: {
				default: null
			}
		},
		mounted () {
			window.addEventListener('scroll', this.scrolled, true)
		},
		data () {
			return {
				scrolledSize: 0
			}
		},
		methods: {
			scrolled () {
				this.scrolledSize = window.scrollY
			}
		},
		beforeDestroy () {
			window.removeEventListener('scroll', this.scrolled, true)
		}
	}
</script>

<style lang="scss" scoped>
    .background {
        background-size: cover;
        background-position: center;
        background-repeat: repeat-y;
        height: 120%;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: -1;
        transform: translate3d(0,0,0);
        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(#fff, 0.5);
        }
    }
</style>
